import { githubAPI } from '../../../api/apiService';
import { GITHUB_TYPE } from './Types';

/**
 * Fetch all GitHub codes
 * @param {Object} params - Parameters object
 * @param {Function} params.dispatch - Dispatch function from useAppDispatch
 * @returns {Promise} - Promise with GitHub codes data
 */
export const fetchGithubCodes = async ({ dispatch }) => {
  try {
    dispatch({
      type: GITHUB_TYPE.IS_LOADING,
      payload: true,
    });

    const response = await githubAPI.getAll();
    const data = response.data?.data || response.data || [];

    dispatch({
      type: GITHUB_TYPE.GITHUBCODES,
      payload: data,
    });

    return {
      success: true,
      data: data,
    };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch GitHub codes';

    dispatch({
      type: GITHUB_TYPE.GITHUBCODES,
      payload: [],
    });

    return {
      success: false,
      error: errorMessage,
    };
  } finally {
    dispatch({
      type: GITHUB_TYPE.IS_LOADING,
      payload: false,
    });
  }
};

/**
 * Create a new GitHub code entry
 * @param {Object} params - Parameters object
 * @param {Function} params.dispatch - Dispatch function from useAppDispatch
 * @param {Object} params.githubData - GitHub code data to create
 * @param {string} params.githubData.title - Project title
 * @param {string} params.githubData.description - Project description
 * @param {string[]} params.githubData.tags - Project tags
 * @param {string} params.githubData.author - Project author
 * @param {string} params.githubData.link - GitHub repository link
 * @param {string} [params.githubData.videoLink] - Optional video link
 * @param {string} [params.githubData.demoLink] - Optional demo link
 * @returns {Promise} - Promise with created GitHub code data
 */
export const createGithubCode = async ({ dispatch, githubData }) => {
  try {
    dispatch({
      type: GITHUB_TYPE.IS_LOADING,
      payload: true,
    });

    const response = await githubAPI.create(githubData);
    const createdCode = response.data?.data || response.data;

    // Refresh the list after creating
    await fetchGithubCodes({ dispatch });

    return {
      success: true,
      data: createdCode,
      message: 'GitHub code created successfully',
    };
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to create GitHub code';

    return {
      success: false,
      error: errorMessage,
    };
  } finally {
    dispatch({
      type: GITHUB_TYPE.IS_LOADING,
      payload: false,
    });
  }
};
